/**
 * @mixin
 */
export default {
    props: {
        /**
         * The width of the dialog at the xl breakpoint
         */
        dialogXlWidth: {
            type: String,
            default: '30%'
        },
        /**
         * The width of the dialog at the lg breakpoint
         */
        dialogLgWidth: {
            type: String,
            default: '40%'
        },
        /**
         * The width of the dialog at the md breakpoint
         */
        dialogMdWidth: {
            type: String,
            default: '50%'
        },
        /**
         * The width of the dialog at the sm breakpoint
         */
        dialogSmWidth: {
            type: String,
            default: '80%'
        },
        /**
         * The width of the dialog at xs sm breakpoint
         */
        dialogXsWidth: {
            type: String,
            default: '100%'
        },
        /**
         * Override the max width of the dialog
         */
        maxWidth: {
            type: [Number, String],
            default: ''
        }
    },
    computed: {
        dialogMaxWidth () {
            const vm = this

            if (vm.maxWidth) {
                return vm.maxWidth
            }

            if (vm.$vuetify.breakpoint.xl) {
                return vm.dialogXlWidth
            }

            if (vm.$vuetify.breakpoint.lg) {
                return vm.dialogLgWidth
            }

            if (vm.$vuetify.breakpoint.md) {
                return vm.dialogMdWidth
            }

            if (vm.$vuetify.breakpoint.smOnly) {
                return vm.dialogSmWidth
            }

            return vm.dialogXsWidth
        }
    }
}
